module.exports = __webpack_public_path__ + "static/media/Icon_9.638ea587.svg";